(function ($) {
  $(function () {

		const apiOptionsFromTheme = apiOptions;
		
		if (apiOptionsFromTheme && apiOptionsFromTheme.api_on_off_status === 0) {
			console.log('--API TURNED OFF--')
			return;
		}
		
		// console.log('--API TURNED ON--')

		// set hard coded fallback defaults
		let fpRateDisplayRangeOption = 'min_only';
		let fpRateSource = 'api_fp_rate';
		let fpRateDisplayTiming = 'on_page_load';
		// get theme options
		if (apiOptionsFromTheme && apiOptionsFromTheme.fp_rate_options) {
			let rateOptions = apiOptionsFromTheme.fp_rate_options;
			if (rateOptions.fp_rate_display_timing) {
				fpRateDisplayTiming = rateOptions.fp_rate_display_timing;
			}
			if (rateOptions.fp_rate_source) {
				fpRateSource = rateOptions.fp_rate_source;
			}
			if (rateOptions.fp_rate_display_range) {
				fpRateDisplayRangeOption = rateOptions.fp_rate_display_range;
			}
			
			if (fpRateSource == 'api_fp_units_calc') {
				// we don't want to show fp rates on page load if they have to be calculated from all available units
				// this would take too many requests 
				fpRateDisplayTiming = 'on_cta_click';
			}
		}

    const toUSD = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0 // (causes 2500.99 to be printed as $2,501)
    });
		
		const closeSvg = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>';
		
		$('body').append(`<dialog id="fp-units-modal"><div class="dialog-package bg-w"></div></dialog>`);
		const unitsModal = $('#fp-units-modal').get(0);
		// console.log('units modal: ', unitsModal);
		const unitsModalCloseHtml = `<button id="fp-units-modal-close" autofocus><span class="sr-only">Close</span>${closeSvg}</button>`;
		// const unitsModalCloseHtml = `<button id="fp-units-modal-close" autofocus><span class="">Close</span></button>`;
		$(unitsModal).on('click', '#fp-units-modal-close', function() { 
			// console.log('close clicked');
			unitsModal.close();
		});

    const updateFloorPlanCards = function (allApiFpData, fpCardSelector) {
      $(fpCardSelector).each((index, floorPlan) => {
        const $fp = $(floorPlan);
				const fpId = $fp.data("leasing-id");
        const fpApiData = allApiFpData[fpId];
				if (!fpApiData) {
					// Nothing from the API for this FP
					if (apiOptionsFromTheme && apiOptionsFromTheme.sold_out_text) {
						$fp.find(".fp-api-details").append(`<div class='fp-rate order-3'>${apiOptionsFromTheme.sold_out_text}</div>`);
					}
					return;
				}

				let minRent = fpApiData.price.min;
				let	minRentNum = parseInt(minRent, 10);
				let	maxRent = fpApiData.price.max;
				let	maxRentNum = parseInt(maxRent, 10);

        let availabilityText = "";
        // let isUrgent = false;
        // let hasAvailable = false;
        // const numAvailable = parseInt(fpApiData.AvailableUnitsCount, 10);
        // if (!isNaN(numAvailable)) {
        //   if (numAvailable > 0) {
        //     hasAvailable = true;
        //   } else {
        //     $fp.addClass('sold-out');
        //   }
        // }
        // if (apiOptionsFromTheme.availability_text_options !== "none") {
        //   if (!isNaN(numAvailable)) {
        //     if (numAvailable == 0) {
        //       availabilityText = apiOptionsFromTheme.sold_out_text;
        //     } else if (numAvailable > parseInt(apiOptionsFromTheme.urgency_threshold, 10)) {
        //       availabilityText = apiOptionsFromTheme.availability_text_template.replace("##", numAvailable);
        //     } else {
        //       availabilityText = apiOptionsFromTheme.urgent_text_template.replace("##", numAvailable);
        //       isUrgent = true;
        //     }
        //   }
        //   if (apiOptionsFromTheme.availability_text_options === "urgent" && isUrgent) {
        //     $fp.find(".fp-api-details").append(`<div class='fp-availability-text order-3'>${availabilityText}</div>`);
        //   } else if (apiOptionsFromTheme.availability_text_options === "all") {
        //     $fp.find(".fp-api-details").append(`<div class='fp-availability-text order-3'>${availabilityText}</div>`);
        //   }
        // }
        if (!isNaN(minRentNum, 10) && minRentNum > 0) {
          const fpStartingPrice = toUSD.format(minRentNum);
					const fpMaxPrice = toUSD.format(maxRentNum);
					if (fpRateDisplayRangeOption == 'min_only') {
						$fp.find(".fp-api-details").append(`<div class='fp-rate order-3'>Rates Starting at ${fpStartingPrice}</div>`);
					} else {
						$fp.find(".fp-api-details").append(`<div class='fp-rate order-3'>Rates from${fpStartingPrice}&ndash;${fpMaxPrice}</div>`);
					}
        } else if (apiOptionsFromTheme && apiOptionsFromTheme.sold_out_text) {
          $fp.find(".fp-api-details").append(`<div class='fp-rate order-3'>${apiOptionsFromTheme.sold_out_text}</div>`);
				}
        // if (
				// 	fpApiData.AvailabilityURL
				// 	&& $fp.find('.application-portal').attr('data-override-link') !== "true"
				// ) {
        //   if (apiOptionsFromTheme.sold_out_link.url && hasAvailable == false) {
        //     // a sold out link has been designated in WP Community Settings and the FP has no availability 
        //     let soldOutLinkUrl =  apiOptionsFromTheme.sold_out_link.url;
        //     let soldOutLinkTarget = apiOptionsFromTheme.sold_out_link.target;
        //     let soldOutLinkRel = '';
        //     let soldOutLinkTitle = '';
        //     let soldOutLinkText = apiOptionsFromTheme.sold_out_link.title;
        //     if (soldOutLinkTarget == '_blank') {
        //       soldOutLinkRel = 'noopener';
        //       soldOutLinkTitle = 'link opens in a new tab';
        //       $fp.find('.application-portal').attr({
        //         'href': soldOutLinkUrl,
        //         'rel': soldOutLinkRel,
        //         'target': soldOutLinkTarget,
        //         'title': soldOutLinkTitle
        //       });
        //     } else {
        //       $fp.find('.application-portal').attr({
        //         'href': soldOutLinkUrl,
        //         'target': '_self'
        //       }).removeAttr('rel').removeAttr('title');
        //     }
        //     $fp.find('.application-portal').text(soldOutLinkText);
        //   } else {
        //     // either the FP has availability, or no no sold out link designated in WP Community Settings
        //     $fp.find('.application-portal').attr('href',fpApiData.AvailabilityURL);
        //   }
        // }
        // either the API didn't return an availability URL or the FP has an override designated  
        // $fp.find(".application-portal").attr("href", fpApiData.AvailabilityURL);
      });
    };
		
		let showUnitsDialog = function(unitCollection, unitCount, fpName, minRate,  maxRate) {
			let funnelApiLeaseBase = 'https://nestiolistings.com/api/v2/onlineleasing-link/?companyID=19155';
			// console.log('unit count: ', unitCount);
			let fpRateDisplayRangeText = '';			
			if (fpRateDisplayTiming == 'on_cta_click') {
				if (fpRateDisplayRangeOption == 'min_only') {
					if (!isNaN(minRate)) {
						fpRateDisplayRangeText = `<p class="dialog-fp-rate-range">Prices starting at ${toUSD.format(minRate)}</p>`;
					}
				} else if (fpRateDisplayRangeOption == 'min_max') {
					if (!isNaN(minRate) && !isNaN(maxRate)) {
						fpRateDisplayRangeText = `<p class="dialog-fp-rate-range">Prices from ${toUSD.format(minRate)}&ndash;${toUSD.format(maxRate)}</p>`;
					}
				}
			}
			
			if (!unitCollection || unitCount == 0) {
				// console.log('No Units');
				let $unitsModalDialogPackage = $(unitsModal).find('.dialog-package');
				$unitsModalDialogPackage.html('');
				let soldOutMessage = `<p class="no-units-message">Please call for details</p>`;
				if (apiOptionsFromTheme.sold_out_text) {
					soldOutMessage = apiOptionsFromTheme.sold_out_text;
				}
				$unitsModalDialogPackage
					.append(unitsModalCloseHtml)
					.append(`<h2 class="floor-plan-name">${fpName}</h2>`)
					.append(`<div class="no-units-message">${soldOutMessage}</div>`);
				unitsModal.showModal();
				return;
			}
			// console.log('units: ', unitCollection);
			let unitRows = unitCollection.map(unit => {
				let communityId = unit.community_id;	
				let unitId = unit.unit_number;
				let leasingLink = '';
				if (communityId == false) {
					leasingLink = 'Call for Pricing';
				} else {
					leasingLink = `<a class="unit-application-link" href="${funnelApiLeaseBase}&UnitID${unitId}&communityID=${communityId}" target="_blank">Apply Now</a>`; 
				}
				let row = 
				`<tr>
					<th scop="row">${unit.unit_number}</th>
					<td>${toUSD.format(unit.price)}</td>
					<td>${leasingLink}</td>
				</tr>`;
				return row;
			})
			let unitsHeader = 
			`<thead>
				<tr>
					<th scope="col">Unit</th>
					<th scope="col">Starting Price</th>
					<th scope="col">Application Link</th>
				</tr>
			</thead>`;
			let unitsBody = 
			`<tbody>
				${unitRows.join('')}
			</tbody>`;
			let unitsTable = `<table>${unitsHeader}${unitsBody}</table>`;
			let $unitsModalDialogPackage = $(unitsModal).find('.dialog-package');
			// $(unitsModal).find('.dialog-package').html('');
			$unitsModalDialogPackage.html('');
			// $(unitsModal).find('.dialog-package').append(unitsModalCloseHtml).append(unitsTable);
			$unitsModalDialogPackage
				.append(unitsModalCloseHtml)
				.append(`<h2 class="floor-plan-name">${fpName}</h2>`)
				.append(fpRateDisplayRangeText)
				.append(unitsTable);
			unitsModal.showModal();
			return;
		}
		
		let calcMinMaxRatesFromUnitsForFP = function(unitCollection) {
			let rateCollection = unitCollection.map(unit => {
				// Funnel API for units is also supposed to have min_price and max_price properties but currently only has data for price
				return parseInt(unit.price, 10);
			});	
			let minPrice = Math.min(...rateCollection);
			let maxPrice = Math.max(...rateCollection);
			return {
				"minRate" : minPrice,
				"maxRate" : maxPrice
			}; 
		}
		
		// Clicked availability CTA on a floor plan card
		$('a.application-portal').on('click', function(e) {
			e.preventDefault();
			let floorPlanId = $(e.target).data('leasing-id');
			let floorPlanName = $(e.target).data('fp-name');
			// console.log('floor plan ID', floorPlanId);
			$.ajax({
				url: `/wp-json/lyst-funnel-listings/available-units/`,
				method: "POST",
				dataType: "json",
				processData: false,
				data: JSON.stringify({
					floor_plan_id: floorPlanId
				})
			})
			.done(resJSON => {
				// console.log('Units: ', resJSON);
				let minRate = '';
				let maxRate = '';
				if (!resJSON.items) {
					showUnitsDialog([], 0, floorPlanName, 0, 0);
					return;
				}
				if (fpRateDisplayTiming == 'on_cta_click' && fpRateSource == 'api_fp_units_calc') {
					let minMaxRateJson = calcMinMaxRatesFromUnitsForFP(resJSON.items);
					// console.log('minMaxRateJson: ', minMaxRateJson);
					minRate = minMaxRateJson.minRate;
					maxRate = minMaxRateJson.maxRate;
				}
				showUnitsDialog(resJSON.items, resJSON.item_count, floorPlanName, minRate, maxRate);
			})
			.fail((req, status, err) => {
				console.log("Error: ", err);
				console.log("Status: ", status);
			});
		});

		if (fpRateDisplayTiming == 'on_page_load') {
			// console.log('Getting rates...');
			$.ajax({
				url: `/wp-json/lyst-funnel-listings/floor-plan-data/`,
				method: "POST",
				dataType: "json",
				processData: false
			})
			.done(resJSON => {
				if (resJSON.error === false) {
					// console.log('RES: ', resJSON);
					const floorPlansById = resJSON['items'].reduce((floorPlanLookupObject, singleFloorPlan) => {
						floorPlanLookupObject[singleFloorPlan.id] = singleFloorPlan;
						return floorPlanLookupObject;
					}, {});
					updateFloorPlanCards(floorPlansById, ".chnl-floor-plan");
				} else {
					console.log('Funnel API Error: ', resJSON.error_message);
				}
			})
			.fail((req, status, err) => {
				console.log("Error: ", err);
				console.log("Status: ", status);
			});
		} 
  });
})(jQuery);
